import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import store from "../store";
import transferIcon from "../assets/images/arrow-left-right.svg";

// ICON
import kotIcon from "../assets/images/KOT-icon.svg";

const TabNavigation = ({ activeTab, setActiveTab, setShowTableSwitch }) => {
  const dineInrunningOrders =
    store.runningKOTs?.filter((order) => order.typeOfOrder !== "Takeaway") ||
    [];
  const parcelRunningOrders =
    store.runningKOTs?.filter((order) => order.typeOfOrder == "Takeaway") || [];
  const partnersRunningOrders = store.partnersOrders || [];

  const [isPartnerEnabled, setIsPartnerEnabled] = useState(false);

  useEffect(() => {
    if (store.restaurantInfo?.partnerDetails?.length > 0) {
      setIsPartnerEnabled(
        store.restaurantInfo.partnerDetails?.find((partner) => partner.enabled)
      );
    }
  }, [store.restaurantInfo?.partnerDetails]);

  const badge = (count) => {
    return (
      <span
        style={{ border: "1px solid black", lineHeight: "1.6" }}
        className="text-xs text-center bg-green-100 text-black rounded-full h-5 w-5"
      >
        {count}
      </span>
    );
  };

  return (
    <div className="flex items-center gap-2 border-b border-gray-300 p-2 px-6 max-w-[100vw] overflow-x-scroll hide-scrollbar">
      {/* Dine In Tab */}
      <NavLink
        to="/table-overview"
        onClick={() => setActiveTab("DineIn")}
        className={({ isActive }) =>
          `text-sm flex items-center justify-center gap-2 px-2 py-1 min-w-[125px]
              ${
                activeTab === "DineIn"
                  ? "bg-[#16A34A] border-[0.5px] border-black rounded text-white"
                  : "border-[0.5px] border-black rounded"
              }`
        }
      >
        Dine In
        {badge(dineInrunningOrders?.length)}
      </NavLink>

      <button
        onClick={() => {
          setActiveTab("Parcel");
        }}
        className={`text-sm px-2 py-1 border-[0.5px] border-black rounded flex items-center justify-center gap-2 block min-w-[125px] ${
          activeTab === "Parcel"
            ? "bg-[#16A34A] border-[0.5px] border-black rounded text-white"
            : ""
        }`}
      >
        Parcel
        {badge(parcelRunningOrders?.length)}
      </button>

      {/* Other Delivery Tab */}
      {isPartnerEnabled && (
        <button
          onClick={() => setActiveTab("Other")}
          className={`
          text-sm px-2 py-1 min-w-[125px]
          border border-black rounded
          flex items-center justify-center gap-2
          ${
            store.partnersConnectionError.length > 0
              ? "bg-red-100 border-red-500 text-red-500"
              : activeTab === "Other"
              ? "bg-[#16A34A] text-white"
              : ""
          }
        `}
        >
          Partners
          {store.partnersConnectionError.length > 0 ? (
            <span
              className="text-xs text-center bg-red-100 text-red-500 rounded-full h-5 w-5"
              style={{ lineHeight: "1.8" }}
            >
              !
            </span>
          ) : (
            badge(partnersRunningOrders?.length)
          )}
        </button>
      )}

      <div className="flex-1"></div>
      <button
        onClick={() => store.setShowRunningKOT(true)}
        className="text-sm px-2 py-1 border-[0.5px] border-black rounded flex items-center justify-center gap-2 block min-w-[135px] max-w-[135px]"
      >
        <img src={kotIcon} alt="Running KOTs" />
        Running KOTs
      </button>
      <button
        onClick={() => setShowTableSwitch(true)}
        className="text-sm px-2 py-1 border-[0.5px] border-black rounded flex items-center justify-center gap-2 block min-w-[135px] max-w-[135px]"
      >
        <img src={transferIcon} />{" "}
        <span className="text-xs md:text-sm">Table Transfer</span>
      </button>
    </div>
  );
};

export default TabNavigation;
